import {
  LocatableType,
  Order,
  OrderableType,
  OrderItemMembership,
} from "@/fm/data/orders";

/**
 * Country of the location a membership order is scoped to.
 *
 * A membership order has no space, so there is no space -> location lookup to
 * fall back on the way a booking order has. The membership carries its own
 * locatable instead, and the order payload already includes that location's
 * country — so no extra request is needed to know which jurisdiction the
 * receipt belongs to.
 *
 * Returns undefined for GeoMarket- and partner-wide memberships: those span
 * several countries, so no single one describes the receipt.
 */
export function membershipLocatableCountry(order?: Order): string | undefined {
  const membership = order?.orderItems.find(
    (item): item is OrderItemMembership =>
      item.type === OrderableType.Membership
  );

  const orderable = membership?.orderable;
  if (orderable?.locatableType !== LocatableType.Location) return undefined;

  const { locatable } = orderable;
  if (!locatable || !("country" in locatable)) return undefined;

  return locatable.country ?? undefined;
}
